import { NgClass } from '@angular/common';
import { Component, HostListener, Input, TemplateRef, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';

@Component({
  selector: 'onboarding-exit-intent',
  templateUrl: './exit-intent.component.html',
  styleUrls: ['./exit-intent.component.scss'],
  imports: [NgClass, TranslocoPipe, ButtonComponent],
})
export class ExitIntentComponent {
  @Input() public variant: string;

  @ViewChild('modal') public modal: TemplateRef<HTMLElement>;

  private readonly _cacheKey = 'exit-intent-seen';

  constructor(private _modal: NgbModal) {}

  @HostListener('document:mouseout', ['$event'])
  public mouseout = (e: MouseEvent) => this.shouldShow(e.relatedTarget) && this.show();

  public continue = () => this._modal.dismissAll();

  private shouldShow = (target: EventTarget): boolean => !target && !this.isOpen() && !this.hasSeen();
  private hasSeen = (): boolean => localStorage.getItem(this._cacheKey) !== null;
  private setSeen = (): void => localStorage.setItem(this._cacheKey, true.toString());
  private show = (): void => this._modal.open(this.modal, { modalDialogClass: 'exit-intent' }) && this.setSeen();
  private isOpen = (): boolean => this._modal.hasOpenModals();
}
